import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import UsersEvents from './UsersEvents';

import UsersDetailsSectionInfo from './details/sections/UsersDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<UsersDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="user_descriptionhtml"
				value={props.model.user_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: UsersEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
